const Public = {
  /**
   * Get calorie logs for a specific user and date
   * @param {Object} params - Parameters containing userId and date
   * @returns {Promise} API response
   */
  userCalorieLogs: {
    url: "/user/log",
    method: "GET",
  },
  /**
   * Get calorie logs by user ID
   * @param {string} id - The ID of the user
   * @returns {Object} Endpoint configuration for fetching calorie logs by user ID
   */

  userCalorieLogsById: (id) => ({
    url: `/user/log/${id}`,
    method: "GET",
  }),
  /**
   * add support for a specific user
   * @param {Object} params - Parameters containing bodyData
   * @returns {Promise} API response
   */
  addSupport: {
    url: "/support",
    method: "POST",
  },
};

export default Public;
